import { GrupoSeguroSelecionado } from './proposta/grupo-seguro-selecionado';
import { GrupoAssistenciaSelecionado } from './proposta/grupo-assistencia-selecionado';

export class DadoSimulacaoSeguro {

  retorno = 0;
  gruposSeguroIds: GrupoSeguroSelecionado[] = [];
  gruposAssistenciaIds: any[] = [];

  setRetorno(retorno: number) {
    this.retorno = retorno;
  }

  getRetorno(): number {
    return this.retorno;
  }

  getPercRetorno(): number {
    return (this.retorno || 0);
  }

  setGrupoSeguroIds(gruposSeguroIds: GrupoSeguroSelecionado[]) {
    this.gruposSeguroIds = gruposSeguroIds;
  }

  getGrupoSeguroIds(): GrupoSeguroSelecionado[] {
    return this.gruposSeguroIds;
  }

  setGrupoAssistenciaIds(gruposAssistenciaIds: GrupoAssistenciaSelecionado[], index) {
    this.gruposAssistenciaIds[index] = gruposAssistenciaIds;
  }

  getGrupoAssistenciaIds(): any[] {
    return this.gruposAssistenciaIds;
  }
}
